import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions, useLoaders } from '@/shared';
import { useGetContrato } from '@/shared/actions/erp';
import { SaveContractFibra } from '../../shared/components';

export type ClienteWirelessPageProps = {};

const ClienteWirelessPage: React.FC<ClienteWirelessPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_view_contrato);
  const clientesWirelessReturnUrl =
    ROUTER_PATHS.clientes.wirelessNav;
  const { id } = useParams();

  const { data, isLoading, isRefetching } = useGetContrato(id!);

  useLoaders(isLoading || isRefetching);

  // comment this 'cause of invalidateQuery
  if (isLoading /* || isRefetching */) return null;
  if (!data?.data?.id_contrato)
    return <Navigate to={clientesWirelessReturnUrl} replace={true} />;

  return <SaveContractFibra contract={data?.data} />;
};

export default ClienteWirelessPage;
